const S = "adyen-pe-transactions", A = `${S}-overview`, t = `${S}-details`, _ = `${A}__summary`, s = `${_}-item`, n = 24;
export {
  A as BASE_CLASS,
  t as BASE_CLASS_DETAILS,
  n as MAX_TRANSACTIONS_DATE_RANGE_MONTHS,
  _ as SUMMARY_CLASS,
  s as SUMMARY_ITEM_CLASS
};
